<script>
  import { Modal } from "../lib/stores/modal";
  import { link } from "svelte-navigator";
  import ProductDetails from "../lib/components/modals/ProductDetails.svelte";
  import ListItem from "../lib/components/products/ListItem.svelte";
  import { onMount } from "svelte";
  import Filters from "../lib/stores/filters";
  let all_products = [];
  let products = [];
  export let cat;
  export let query;
  export let title = "";
  let mainMenuItems = [];
  let queryURL = () => {
    let url = "https://crm.lamara.in/products/products/productslist/";
    if ($Filters.product_sort) {
      url += $Filters.product_sort;
    }
    if (cat || query) {
      url += "?";
      if (query) {
        url += `q=${query}`;
      } else if (cat) {
        url += `cat=${cat}`;
      }
    }
    return url;
  };
  const loadProducts = () => {
    //let url = query ? `https://crm.lamara.in/products/products/search/?q=${query}` : cat ? `https://crm.lamara.in/products/products/productslist/${$Filters.product_sort ? $Filters.product_sort : '' }?cat=${cat}` : `https://crm.lamara.in/products/products/productslist/${$Filters.product_sort ? $Filters.product_sort : '' }`;
    fetch(queryURL())
      .then((res) => res.json())
      .then((res) => {
        products = query ? res.data.products : res.data;
        all_products = [...products];
      });
    fetch("https://crm.lamara.in/products/products/apiitemlist")
      .then((res) => res.json())
      .then((res) => {
        mainMenuItems = res.data;
      });
  };
  $: if (mainMenuItems.length) {
    let menu = mainMenuItems.find((i) => i.id == cat);
    if (menu) {
      title = menu.name;
    }
  }
  onMount(() => {
    loadProducts();
  });
  //$: $Filters.product_sort, query, loadProducts();
  Filters.subscribe((f) => {
    products = [];
    if (f.filters_list.length || f.product_sizes.length) {
      fetch("https://crm.lamara.in/products/products/productsbyfilters", {
        method: "POST",
        body: JSON.stringify({
          data: f,
        }),
      })
        .then((res) => res.json())
        .then((res) => {
          if (!res.error) products = res.data;
          else products = [];
        });
    } else {
      products = all_products;
    }
  });
</script>

<div class="banner-box">
  <img src="../images/banners/1.jpg" alt="Product Banner" />
</div>
<section id="products" class="products">
  <div class="container">
    <h2 class="section-title">
      {title}
    </h2>
    <div class="row show-case-items">
      {#each products as product}
        <ListItem {product} />
      {:else}
        <!-- Oops! No cakes found! -->
        Baking in process....
      {/each}
      {#if mainMenuItems.length}
        <div class="col-12">
          <h2 class="section-title top-border text-capitalize">Menu Categories</h2>
          <div class="row show-case-items">
            {#if mainMenuItems && mainMenuItems.length}
              {#each mainMenuItems as category}
                {#if category.id != cat}
                  <div class="col-6 col-md-4">
                    <a class="item-box" href="/cat/{category.id}">
                      <div class="product text-center">
                        <img
                          src={category.item_img && category.item_img != "N/A"
                            ? category.item_img
                            : "/images/ccakes.jpeg"}
                          class="img-responsive"
                        />
                      </div>
                      <div class="caption">
                        <h5>
                          {category.name}
                        </h5>
                      </div>
                    </a>
                  </div>
                {/if}
              {/each}
            {/if}
          </div>
        </div>
      {/if}
    </div>
  </div>
</section>

<style lang="scss">
  .section-title {
    padding: 25px 0 0px 0;
    margin-bottom: 0;
    // font-family: 'Arizonia', cursive;
    font-family: var(--primary-font);
    color: #434343;
    font-size: 22px;
    text-align: center;
  }

  .products {
    position: relative;
    padding-bottom: 40px;
  }

  .products::before {
    // content: '';
    // background-image: url("/images/web-pattern-gold-body.png");
    // opacity: 0.7;
    // top: 0;
    // left: 0;
    // bottom: 0;
    // right: 0;
    // position: absolute;
    // z-index: -1;
    // background-blend-mode: screen;
  }

  .caption {
    h5 {
      padding: 6px 4px;
      font-family: var(--primary-font);
      color: #434343;
      margin: 0;
      font-size: 17px;
      text-transform: uppercase;
      position: relative;
      min-height: 48px;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
    }
  }

  .product img {
    border-radius: 16px;
  }

  .section-title {
    margin-bottom: 10px;
  }

  .top-border {
    border-top: 1px solid #ccc;
    margin: 60px 0 24px 0;
  }

</style>